import ToyBricks from '~/pages/ToyBricks/reducers'
import recharge from '~/pages/recharge/reducers'
import AnnualSum2022 from '~/pages/AnnualSum2022/reducers'
import Ramadan2024 from '~/pages/Ramadan2024/reducers'
import AnnualActivity2024 from '~/pages/AnnualActivity2024/reducers'
import AnnualActivity2025 from '~/pages/AnnualActivity2025/reducers'
import KillAnimal from '~/pages/KillAnimal/reducers'

export default {
  ToyBricks,
  recharge,
  AnnualSum2022,
  Ramadan2024,
  AnnualActivity2024,
  AnnualActivity2025,
  KillAnimal,
}
